module.exports = __webpack_public_path__ + "static/web-1-99701e9e157141cda22c74d69fa2eedc.svg";